/*----------------------------------
- AI MARKDOWN MIRRORS
----------------------------------*/

import { appErrorReporter } from '@/common/libs/errorReporting';
const decodePathToken = (value: string | undefined): string | undefined => {
    if (!value) return undefined;

    try {
        return decodeURIComponent(value).trim();
    } catch (error) {
        appErrorReporter.app.handleError(error);
        console.warn('[domains] Could not decode AI markdown mirror path token.', error);
        return value.trim();
    }
};

const toMirrorSlug = (value: string | undefined): string | undefined => {
    const normalized = value
        ?.trim()
        .toLowerCase()
        .replace(/^\./, '')
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9.]+/g, '-')
        .replace(/^-+|-+$/g, '');

    return normalized || undefined;
};

// No TLD branch: the `/domains/tld/<slug>` listings retired for the `/tld/<slug>` insight pages
// (ADR-0054), which name their own mirrors.
export const resolveDomainsMarkdownMirrorPath = (currentPath: string): string => {
    const normalizedPath = currentPath.split('?')[0]?.replace(/\/+$/, '') || '/domains';
    const sectorMatch = normalizedPath.match(/^\/domains\/sector\/([^/]+)$/);
    const slugMatch = normalizedPath.match(/^\/domains\/([^/]+)$/);

    if (sectorMatch?.[1]) {
        const sector = toMirrorSlug(decodePathToken(sectorMatch[1]));
        return sector ? `/ai/sectors/${sector}.md` : '/ai/domains.md';
    }

    if (slugMatch?.[1]) {
        return '/ai/domains.md';
    }

    return '/ai/domains.md';
};

export const resolveDomainsFullMarkdownMirrorPath = (currentPath: string): string => {
    const url = new URL(currentPath, 'https://unique.domains');
    const normalizedPath = url.pathname.replace(/\/+$/, '') || '/domains';
    const markdownPath = normalizedPath === '/domains' ? '/domains.md' : `${normalizedPath}.md`;

    return `${markdownPath}${url.search}`;
};
